import { Component, Input } from '@angular/core';

import { BarChartDatePeriod } from '../../../../tms-shared';
import { ChartWeeksPurchaseOrdersService } from '../../../services';

@Component({
  selector: 'app-purchase-order-chart',
  templateUrl: './purchase-order-chart.component.html',
  styleUrl: './purchase-order-chart.component.scss',
})
export class PurchaseOrderChartComponent {
  @Input() productId: string = '';
  @Input() supplierId: string = '';
  @Input() barChartPeriod: BarChartDatePeriod = BarChartDatePeriod.Week;
  @Input() xRotation: number = 0;

  readonly yNamePurchaseValue = $localize`Purchase Value`;

  constructor(public chartWeeksPurchaseOrdersService: ChartWeeksPurchaseOrdersService) {}
}
